import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { SummaryData } from '../../types/state';
import { FetchDataSummaryParams, FetchDataSummarySuccessPayload } from '../../types/request';
import { buildDataSummary } from '../../utils/data-table';

const initialState: SummaryData = {
  data: [],
  fetchingStatusSummaryData: false,
  error: null
};

export const dataSummary = createSlice({
  name: NameSpace.DataSummary,
  initialState,
  reducers: {
    fetchDataSummaryRequest: (state, payload: PayloadAction<FetchDataSummaryParams>) => {
      state.fetchingStatusSummaryData = true;
    },
    fetchDataSummarySuccess: (state, action: PayloadAction<FetchDataSummarySuccessPayload>) => {
      state.fetchingStatusSummaryData = false;
      const { data, params } = action.payload;
      console.log('params', params);
      state.data = buildDataSummary(data, params.quarter, params.year);
    },
  },
});

export const { fetchDataSummaryRequest, fetchDataSummarySuccess } = dataSummary.actions;
